// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__PropertyType = require("./PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.bs.js");
let PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.bs.js");
let PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql.bs.js");
let PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql.bs.js");
let PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql.bs.js");

function PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$LotSizeField(props) {
  let lotSize = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.lotSize = value;
      return newrecord;
    }
  }, props.stepHasBeenTouched, props.lotSize, props.isLotSizeValid);
  return JsxRuntime.jsx(PropertyWizardFormRelay__Elements.IntInputField.make, {
    label: "Lot Size",
    append: "sqft",
    optionalText: props.isLot ? undefined : "optional",
    onChange: value => lotSize.onChange(value),
    onBlur: param => lotSize.onBlur(),
    value: lotSize.valueAsString,
    validationResult: PropertyWizardRelayUtils.FormUtils.toValidationResult(lotSize.valid)
  });
}

let LotSizeField = {
  make: PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$LotSizeField
};

let convertFragment = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$MultiUnitAttributes(props) {
  let localDraft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesMultiUnit_draft_graphql.node, convertFragment, props.localDraft);
  let numberOfUnits = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.numberOfUnits = value;
      return newrecord;
    }
  }, props.stepHasBeenTouched, localDraft.draftProperty.numberOfUnits, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.NumberOfUnits.useIsValid(localDraft.fragmentRefs));
  return JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    widthMd: 4,
    children: JsxRuntime.jsx(PropertyWizardFormRelay__Elements.IntInputField.make, {
      label: "Number of units",
      onChange: value => numberOfUnits.onChange(value),
      onBlur: param => numberOfUnits.onBlur(),
      value: numberOfUnits.valueAsString,
      validationResult: PropertyWizardRelayUtils.FormUtils.toValidationResult(numberOfUnits.valid)
    })
  });
}

let MultiUnitAttributes = {
  DraftFragment: DraftFragment,
  make: PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$MultiUnitAttributes
};

let convertFragment$1 = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$LotAttributes(props) {
  let localDraft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesLot_draft_graphql.node, convertFragment$1, props.localDraft);
  let isLotSizeValid = PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.LotSize.useIsValid(localDraft.fragmentRefs);
  return JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    widthMd: 4,
    children: JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$LotSizeField, {
      isLot: true,
      lotSize: localDraft.draftProperty.lotSize,
      isLotSizeValid: isLotSizeValid,
      stepHasBeenTouched: props.stepHasBeenTouched
    })
  });
}

let LotAttributes = {
  DraftFragment: DraftFragment$1,
  make: PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$LotAttributes
};

let convertFragment$2 = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql.node, convertFragment$2, fRef);
}

let DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$SingleFamilyAndCondoAttributes(props) {
  let stepHasBeenTouched = props.stepHasBeenTouched;
  let localDraft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributesSingleFamilyAndCondo_draft_graphql.node, convertFragment$2, props.localDraft);
  let isLotSizeValid = PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.LotSize.useIsValid(localDraft.fragmentRefs);
  let beds = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.beds = value;
      return newrecord;
    }
  }, stepHasBeenTouched, localDraft.draftProperty.beds, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.Beds.useIsValid(localDraft.fragmentRefs));
  let baths = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.baths = value;
      return newrecord;
    }
  }, stepHasBeenTouched, localDraft.draftProperty.baths, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.Baths.useIsValid(localDraft.fragmentRefs));
  let halfBaths = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.halfBaths = value;
      return newrecord;
    }
  }, stepHasBeenTouched, localDraft.draftProperty.halfBaths, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.HalfBaths.useIsValid(localDraft.fragmentRefs));
  let livingArea = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.livingArea = value;
      return newrecord;
    }
  }, stepHasBeenTouched, localDraft.draftProperty.livingArea, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.LivingArea.useIsValid(localDraft.fragmentRefs));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(PropertyWizardFormRelay__Elements.IntInputField.make, {
          label: "Beds",
          onChange: value => beds.onChange(value),
          onBlur: param => beds.onBlur(),
          value: beds.valueAsString,
          validationResult: PropertyWizardRelayUtils.FormUtils.toValidationResult(beds.valid)
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(PropertyWizardFormRelay__Elements.IntInputField.make, {
          label: "Baths",
          onChange: value => baths.onChange(value),
          onBlur: param => baths.onBlur(),
          value: baths.valueAsString,
          validationResult: PropertyWizardRelayUtils.FormUtils.toValidationResult(baths.valid)
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(PropertyWizardFormRelay__Elements.IntInputField.make, {
          label: "Half Baths",
          optionalText: "optional",
          onChange: value => halfBaths.onChange(value),
          onBlur: param => halfBaths.onBlur(),
          value: halfBaths.valueAsString,
          validationResult: PropertyWizardRelayUtils.FormUtils.toValidationResult(halfBaths.valid)
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(PropertyWizardFormRelay__Elements.IntInputField.make, {
          label: "Living Area",
          append: "sqft",
          optionalText: "optional",
          onChange: value => livingArea.onChange(value),
          onBlur: param => livingArea.onBlur(),
          value: livingArea.valueAsString,
          validationResult: PropertyWizardRelayUtils.FormUtils.toValidationResult(livingArea.valid)
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$LotSizeField, {
          isLot: false,
          lotSize: localDraft.draftProperty.lotSize,
          isLotSizeValid: isLotSizeValid,
          stepHasBeenTouched: stepHasBeenTouched
        })
      })
    ]
  });
}

let SingleFamilyAndCondoAttributes = {
  DraftFragment: DraftFragment$2,
  make: PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$SingleFamilyAndCondoAttributes
};

let convertFragment$3 = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.node, convertFragment$3, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let DraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let DraftFragment$3 = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes(props) {
  let stepHasBeenTouched = props.stepHasBeenTouched;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyTypePropertyAttributes_draft_graphql.node, convertFragment$3, props.draft);
  let draftProperty = draft.draftProperty;
  let forSalePropertyType = draftProperty.forSalePropertyType;
  let propertyType;
  if (forSalePropertyType !== undefined) {
    propertyType = forSalePropertyType;
  } else {
    let rentalPropertyType = draftProperty.rentalPropertyType;
    propertyType = rentalPropertyType !== undefined ? rentalPropertyType : undefined;
  }
  if (propertyType === undefined) {
    return null;
  }
  switch (propertyType) {
    case "LOT" :
      return JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$LotAttributes, {
        localDraft: draft.fragmentRefs,
        stepHasBeenTouched: stepHasBeenTouched
      });
    case "MULTI_UNIT" :
      return JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$MultiUnitAttributes, {
        localDraft: draft.fragmentRefs,
        stepHasBeenTouched: stepHasBeenTouched
      });
    case "CONDO" :
    case "SINGLE_FAMILY" :
      return JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes$SingleFamilyAndCondoAttributes, {
        localDraft: draft.fragmentRefs,
        stepHasBeenTouched: stepHasBeenTouched
      });
  }
}

let Components;

let FormSection;

let Grid;

let Cell;

let Form;

let FormUtils;

let FormElements;

let Validators;

let make = PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Grid = Grid;
exports.Cell = Cell;
exports.Form = Form;
exports.FormUtils = FormUtils;
exports.FormElements = FormElements;
exports.Validators = Validators;
exports.LotSizeField = LotSizeField;
exports.MultiUnitAttributes = MultiUnitAttributes;
exports.LotAttributes = LotAttributes;
exports.SingleFamilyAndCondoAttributes = SingleFamilyAndCondoAttributes;
exports.DraftFragment = DraftFragment$3;
exports.make = make;
/* react/jsx-runtime Not a pure module */
